import { useIntl } from 'react-intl';

import { CompanySizeRange, Maybe } from '@/graphql/generated';

export const useCompanyRange = (companySizeRange: Maybe<CompanySizeRange> | undefined): string => {
  const { formatNumber } = useIntl();
  if (companySizeRange) {
    return companySizeRange.max
      ? `${formatNumber(companySizeRange.min)} - ${formatNumber(companySizeRange.max)}`
      : `${formatNumber(companySizeRange.min)}`;
  }
  return '';
};
